var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m15.867 14.573-4.14-4.17a.46.46 0 0 1-.05-.583c1.697-2.603 1.3-6.183-1.203-8.322-2.41-2.057-6.078-1.987-8.412.156a6.374 6.374 0 0 0-.202 9.194c2.17 2.173 5.53 2.436 7.997.804a.46.46 0 0 1 .584.051l4.13 4.162c.18.18.47.18.649.001l.646-.647a.46.46 0 0 0 0-.646zM3.152 9.554a4.54 4.54 0 0 1 0-6.412 4.53 4.53 0 0 1 6.407 0 4.54 4.54 0 0 1 0 6.412 4.533 4.533 0 0 1-6.407 0"
})));
export { SvgSearch as ReactComponent };
export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvbWVkaWEvc2VhcmNoLjQyYWQwN2Q4LnN2ZyI7";